const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Avoid Back Date',
  description: 'Avoid choosing previous dates from today will be enabled if it is false',
  sortOrder: 1,
  name: 'avoid_back_date',
  documentKey: 'avoid_back_date',
  values: {
    loading_date: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Loading Date',
      documentKey: 'loading_date',
    },
    truck_in: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Truck In',
      documentKey: 'truck_in',
    },
    truck_out: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Truck Out',
      documentKey: 'truck_out',
    },
    reported_date: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Reported Date',
      documentKey: 'reported_date',
    },
    release_date: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Release date',
      documentKey: 'release_date',
    },
  },
};
